var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#898e9a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.921,5H7.243A2.022,2.022,0,0,0,5.221,7.022v6.705H3.533A1.035,1.035,0,0,0,2.5,14.761v1.9a2.031,2.031,0,0,0,2.022,2.022H14.906a2.022,2.022,0,0,0,2.022-2.022V7.022A2.008,2.008,0,0,0,14.921,5Zm-9.7,11.814a.681.681,0,0,1-.684.684.844.844,0,0,1-.836-.836V14.913H5.236v1.9ZM7.653,8.071a.441.441,0,0,1,.441-.441H9.858a.441.441,0,0,1,.441.441V10.6a.441.441,0,0,1-.441.441H8.095a.441.441,0,0,1-.441-.441Zm6.417,8H8.094a.441.441,0,0,1,0-.881H14.07a.441.441,0,0,1,0,.881Zm0-2.524H8.094a.441.441,0,0,1,0-.881H14.07a.441.441,0,0,1,0,.881Zm0-2.524H12.078a.441.441,0,1,1,0-.881H14.07a.441.441,0,1,1,0,.881Zm0-2.509H12.078a.441.441,0,1,1,0-.881H14.07a.441.441,0,0,1,0,.881Z",
    transform: "translate(-1.499 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNews);
export default __webpack_public_path__ + "static/media/nav-news.0204319d882c94f2463abb6c133cc011.svg";
export { ForwardRef as ReactComponent };